import { createContext } from 'react'

import { VISITOR_ACCESS_SNAPSHOT } from './constants'
import type { AuthSessionValue } from './types'
import { buildToolCards } from '@/features/commandDeck/config/toolMatrix'

export const defaultAuthSessionValue: AuthSessionValue = {
  status: 'loading',
  access: VISITOR_ACCESS_SNAPSHOT,
  tools: buildToolCards('visitor'),
  error: null,
  refreshAccess: async () => {},
  signOut: async () => {},
}

export const AuthSessionContext = createContext<AuthSessionValue>(defaultAuthSessionValue)
